module.exports = __webpack_public_path__ + "static/media/otras-areas-home.dd69b557.jpg";